module.exports = __webpack_public_path__ + "static/media/buyerup-logo.32a107e5.svg";